module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Verified gross mass (VGM )")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "mt-2"
  }), _vm._v(" "), (_vm.containerNoList.length > 0 || _vm.vgmModel.ffVgmId != '') ? _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Name *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.vgmModel.clientName),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "clientName", $$v)
      },
      expression: "vgmModel.clientName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Registration / License No. *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.vgmModel.clientRegistrationNo),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "clientRegistrationNo", $$v)
      },
      expression: "vgmModel.clientRegistrationNo"
    }
  })], 1), _vm._v(" "), (!_vm.vgmModel.clientRegistrationNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.clientRegistrationNo))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Name and Registration of official of the client\n                    authorized to sign document *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "nameRegistrationOfficial",
      "name": "nameRegistrationOfficial"
    },
    model: {
      value: (_vm.vgmModel.nameRegistrationOfficial),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "nameRegistrationOfficial", $$v)
      },
      expression: "vgmModel.nameRegistrationOfficial"
    }
  })], 1), _vm._v(" "), (!_vm.vgmModel.nameRegistrationOfficial) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.nameRegistrationOfficial))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("24*7 contact No. of authorized official of client\n                    *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "officialContactNo",
      "name": "officialContactNo"
    },
    model: {
      value: (_vm.vgmModel.officialContactNo),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "officialContactNo", $$v)
      },
      expression: "vgmModel.officialContactNo"
    }
  })], 1), _vm._v(" "), (!_vm.vgmModel.officialContactNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.officialContactNo))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [(_vm.vgmModel.ffVgmId == '') ? _c('label', {
    attrs: {
      "for": "containerNo"
    }
  }, [_vm._v("Container No *")]) : _vm._e(), _vm._v(" "), (_vm.vgmModel.ffVgmId == '') ? _c('model-list-select', {
    attrs: {
      "list": _vm.containerNoList,
      "option-value": "uniqueContainerId",
      "option-text": "containerNo",
      "placeholder": "Select Container No"
    },
    model: {
      value: (_vm.vgmModel.ffExecutionContainerId),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "ffExecutionContainerId", $$v)
      },
      expression: "vgmModel.ffExecutionContainerId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerNo"
    }
  }, [_vm._v("Container No *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.vgmModel.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "containerNo", $$v)
      },
      expression: "vgmModel.containerNo"
    }
  })], 1), _vm._v(" "), (!_vm.vgmModel.ffExecutionContainerId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.ffExecutionContainerId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Container Size (TEU/FEU/Other)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ContainerTypeList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type/Size",
      "isDisabled": true
    },
    model: {
      value: (_vm.vgmModel.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "containerTypeId", $$v)
      },
      expression: "vgmModel.containerTypeId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Verfiied Gross mass of container(Method-1/2) *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.massWeightList,
      "option-value": "mwV",
      "option-text": "mwT",
      "placeholder": "Select "
    },
    model: {
      value: (_vm.vgmModel.verifiedConGrossMass),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "verifiedConGrossMass", $$v)
      },
      expression: "vgmModel.verifiedConGrossMass"
    }
  })], 1), _vm._v(" "), (!_vm.vgmModel.verifiedConGrossMass) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.verifiedConGrossMass))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("VGM Weight *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.vgmModel.maxPermissibleWeight != '' ? false : true,
      "type": "number",
      "id": "verifiedConGrossMass",
      "name": "verifiedConGrossMass"
    },
    model: {
      value: (_vm.vgmModel.vgmWeight),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "vgmWeight", $$v)
      },
      expression: "vgmModel.vgmWeight"
    }
  })], 1), _vm._v(" "), (!_vm.vgmModel.vgmWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.vgmWeight))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Maximum permissible weight of container as per the CSC\n                    plate *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "id": "maxPermissibleWeight",
      "name": "maxPermissibleWeight"
    },
    model: {
      value: (_vm.vgmModel.maxPermissibleWeight),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "maxPermissibleWeight", $$v)
      },
      expression: "vgmModel.maxPermissibleWeight"
    }
  })], 1), _vm._v(" "), (!_vm.vgmModel.maxPermissibleWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.maxPermissibleWeight))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Date & time of Weighing *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "weighingDate",
      "id": "weighingDate",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a",
      "minute-step": 1
    },
    model: {
      value: (_vm.vgmModel.weighingDate),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "weighingDate", $$v)
      },
      expression: "vgmModel.weighingDate"
    }
  }), _vm._v(" "), (!_vm.vgmModel.weighingDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.weighingDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "75"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Weighing Slip No *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "weighingSlipNo",
      "name": "weighingSlipNo"
    },
    model: {
      value: (_vm.vgmModel.weighingSlipNo),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "weighingSlipNo", $$v)
      },
      expression: "vgmModel.weighingSlipNo"
    }
  })], 1), _vm._v(" "), (!_vm.vgmModel.weighingSlipNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.weighingSlipNo))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Weighbridge Registration No. *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "weighbridgeRegNo",
      "name": "weighbridgeRegNo"
    },
    model: {
      value: (_vm.vgmModel.weighbridgeRegNo),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "weighbridgeRegNo", $$v)
      },
      expression: "vgmModel.weighbridgeRegNo"
    }
  })], 1), _vm._v(" "), (!_vm.vgmModel.weighbridgeRegNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.weighbridgeRegNo))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Weighbridge Address *")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "weighbridgeAddress",
      "name": "weighbridgeAddress"
    },
    model: {
      value: (_vm.vgmModel.weighbridgeAddress),
      callback: function($$v) {
        _vm.$set(_vm.vgmModel, "weighbridgeAddress", $$v)
      },
      expression: "vgmModel.weighbridgeAddress"
    }
  })], 1), _vm._v(" "), (!_vm.vgmModel.weighbridgeAddress) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.weighbridgeAddress))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "65"
    }
  }, [_c('label', {
    attrs: {
      "for": "autoCommodity"
    }
  }, [_vm._v("Commodity")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.commodityList,
      "option-value": "commodityId",
      "option-text": "itemDescription",
      "placeholder": "Select Commodity",
      "isDisabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.commodityId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodityId", $$v)
      },
      expression: "ffExoprtDetail.commodityId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Commodity Type")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "commodityType",
      "name": "commodityType",
      "disabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodityType", $$v)
      },
      expression: "ffExoprtDetail.commodityType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "itemDescription"
    }
  }, [_vm._v("Item Description")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "itemDescription",
      "name": "itemDescription",
      "disabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.itemDescription),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "itemDescription", $$v)
      },
      expression: "ffExoprtDetail.itemDescription"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Hazardous') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("IMDG Class")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "IMDGClass",
      "name": "IMDGClass",
      "disabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.IMDGClass),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "IMDGClass", $$v)
      },
      expression: "ffExoprtDetail.IMDGClass"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("UN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "UNNumber",
      "name": "UNNumber",
      "disabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.UNNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "UNNumber", $$v)
      },
      expression: "ffExoprtDetail.UNNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Packing Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packingCode",
      "name": "packingCode",
      "disabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.packingCode),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "packingCode", $$v)
      },
      expression: "ffExoprtDetail.packingCode"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.addVGM
    }
  }, [_vm._v(_vm._s(_vm.vgmModel.ffVgmId != "" ? "Update" : "Save") + " &\n                  Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.vgmArrayList.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('div', [_c('h5', [_c('b-badge', [_vm._v("VGM Details")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "poTablefdfdf"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("ContainerNo")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.vgmArrayList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerType))]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "variant": "outline-info",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.viewEdit(item)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "outline-info",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.Print(item.uploadVgm)
        }
      }
    }, [_vm._v("PDF")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "outline-info",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.downloadWord(item.ffVgmId)
        }
      }
    }, [_vm._v("WORD FILE")])], 1)])
  }))])])]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopMaxPer",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.clearPermisibleWgt
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2e96194","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/newVgmDetail.vue
// module id = 2821
// module chunks = 0